// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    /** API staging (build por defecto sin reemplazo de env). Para API local: `'/api'` + proxy en tu copia local sin subir. */
    API_URL: 'https://staging-api.finapartner.com/api',
    /** Fallback de tenant en login cuando el host no trae subdominio (p. ej. solo localhost:4200). Debe existir en `tenants`. */
    localDevTenantId: '',
    /**
     * Hostnames (solo host, sin puerto) donde el login no infiere tenant del subdominio.
     * Debe coincidir con UNIFIED_LOGIN_HOSTNAMES en la API. Vacío en local salvo pruebas explícitas.
     */
    /** Prueba local login unificado: mismo valor que UNIFIED_LOGIN_HOSTNAMES en la API al arrancar. */
    unifiedLoginHostnames: ['login.fina.business'] as string[],
    /**
     * URL absoluta de entrada de sesión (para enlaces desde registro u otros sitios externos).
     * Vacío = no se muestran CTAs con URL absoluta (solo rutas relativas /auth/login).
     */
    LOGIN_ENTRY_URL: '',
    /** Dominio base para construir URLs de subdominio por tenant: `{tenantId}.{dominio}`. Vacio = no redirect. */
    tenantSubdomainBaseUrl: 'fina.business',
    /** Cookie compartida (Domain padre) para redirigir desde login unificado al último tenant. Vacío = desactivado en local sin dominio real. */
    lastTenantCookieName: 'FINA_LAST_TENANT',
    lastTenantCookieDomain: '.fina.business',
    lastTenantCookieMaxAgeDays: 30,
    // API_URL: '/api',
    // API_URL: 'http://localhost:4000/api',
    // selfRegistrationUrl: 'http://localhost:4200/registration/create-account',
    selfRegistrationUrl: 'https://registro.fina.business/registration/create-account',
    /** Temporary landing for buying extra associated users until Admin checkout exists. */
    additionalUsersPurchaseUrl: 'https://www.finapartner.com/',

    POSTHOG_KEY: 'phc_fhLG0mu6idevm2S3kSAb7pOsEtCq2MfsSzmWGrIb4Bh',
    POSTHOG_HOST: 'https://p.finapartner.com',

    INTERCOM_APP_ID: 't2hw46qi',

    // Bank account ID for payment validation (BNC account)
    VALIDATABLE_BANK_ACCOUNT_ID: '689e1bbf223716215535a925', // Staging BNC account

    DOWNLOADABLES_URL: 'https://downloadables-staging.s3.us-east-2.amazonaws.com/',

    finaPrintUrl: 'http://127.0.0.1:8000',
    /** Clave publicable de Stripe (segura para el cliente). Test key en staging. */
    STRIPE_PUBLISHABLE_KEY: 'pk_test_51PEzD8HFoRAtmZVwFmGXdybiRJd3AzGKkpc5jdsVfZDbiflbguRuoKcL8uT6pBtArOsiqvrlYb3SoYvvQR8MeslD00tWWmI5ss',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
